import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { InputRemovableImage } from 'molecules';
import { FullWidthFlexboxCentered, Width200, Mr2, Mt2, FitRelativeWrapper, FlexCenterJustifyCenterWrapper } from 'wrappers';
import { FilesCount } from './atoms';

export const definition = {
  name: "NoteMediaFiles",
  controller: Controller,
  initialProps: ({ files, popup, alignLeft }) => ({ files, popup, alignLeft }),
  props: internalState,
  elements: [
    {
      component: InputRemovableImage,
      name: 'Image',
      renderIf: ({ files, alignLeft }) => files.length === 1 && alignLeft,
      bindings: ({ files, popup }) => ({
        ...files[0],
        displayBackground: true,
        width: files[0].content_type.includes("image") ? '176px' : files[0].content_type.includes("video") ? '250px' : '76px',
        height: files[0].content_type.includes("image") || files[0].content_type.includes("video") ? '250px' : '76px',
        popup: !files[0].content_type.includes("image") && !files[0].content_type.includes("video") ? { text: 'Click to download document', position: 'top' } : popup
      })
    },
    {
      component: wrap(InputRemovableImage, FlexCenterJustifyCenterWrapper),
      name: 'Image',
      renderIf: ({ files, alignLeft }) => files.length === 1 && !alignLeft,
      bindings: ({ files, popup }) => ({
        ...files[0],
        displayBackground: true,
        width: files[0].content_type.includes("image") ? '176px' : files[0].content_type.includes("video") ? '250px' : '76px',
        height: files[0].content_type.includes("image") || files[0].content_type.includes("video") ? '250px' : '76px',
        popup: !files[0].content_type.includes("image") && !files[0].content_type.includes("video") ? { text: 'Click to download document', position: 'top' } : popup
      })
    },
    {
      wrapper: wrap(FullWidthFlexboxCentered, Width200),
      name: 'MultipleFilesWrapper',
      elements: [
        {
          component: wrap(wrap(InputRemovableImage, Mr2), Mt2),
          name: 'Image',
          renderIf: ({ files }) => files.length > 1,
          isListOf: { file: ({ files }) => files.slice(0, 3) },
          bindings: ({ file, popup }) => ({
            ...file,
            width: '75px',
            displayBackground: true,
            height: '75px',
            popup: !file.content_type.includes("image") && !file.content_type.includes("video") ? { text: 'Click to download document', position: 'top' } : popup
          })
        },
        {
          wrapper: wrap(wrap(FitRelativeWrapper, Mr2), Mt2),
          name: 'MoreImages',
          renderIf: ({ files }) => !!files[3],
          isButton: true,
          bindings: ({ files }) => ({ url: files[3].url }),
          elements: [
            {
              component: InputRemovableImage,
              name: 'Image',
              bindings: ({ files, popup }) => ({
                ...files[3],
                width: '75px',
                displayBackground: true,
                height: '75px',
                popup: !files[3].content_type.includes("image") && !files[3].content_type.includes("video") ? { text: 'Click to download document', position: 'top' } : popup
              })
            },
            {
              component: FilesCount,
              name: 'FilesCount',
              renderIf: ({ files }) => files.length > 4,
              displayValue: ({ files }) => `+ ${files.length - 3}`
            }
          ]
        },
      ]
    }
  ]
}

export default ContainerComponent(definition);
